// src/context/NotificationContext.js

import React, { createContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (message, severity = "info") => {
    setNotifications((prevNotifications) => [
      ...prevNotifications,
      { message, severity, id: Date.now() },
    ]);
  };

  const removeNotification = (id) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((notification) => notification?.id !== id)
    );
  };

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      {notifications?.map((notification) => (
        <Snackbar
          key={notification?.id}
          open={true}
          autoHideDuration={6000}
          onClose={() => removeNotification(notification?.id)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => removeNotification(notification?.id)}
            severity={notification?.severity}
            sx={{ width: "100%" }}
          >
            {notification?.message}
          </Alert>
        </Snackbar>
      ))}
    </NotificationContext.Provider>
  );
};
